$('#faq-qa-fixed-content-section').ready(async function () {
  //init tabs
  var faq_tab = (function (section) {
    var tabs = section.querySelectorAll('.tab_contents')
    var buttons = section.querySelectorAll('.tab_link')

    var onClick = function (evt) {
      var button = evt.target
      var tabName = button.getAttribute('data-tab')
      var tab = section.querySelector('.tab_contents[data-tab="' + tabName + '"]')
      if (!tab) {
        return
      }

      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i]
        var _tabName = tab.getAttribute('data-tab')
        if (_tabName === tabName) {
          tab.classList.add('flex')
          tab.classList.remove('hidden')
        } else {
          tab.classList.remove('flex')
          tab.classList.add('hidden')
        }
      }

      for (var i = 0; i < buttons.length; i++) {
        var button = buttons[i]
        var _tabName = button.getAttribute('data-tab')
        if (_tabName === tabName) {
          button.classList.add('border-b-2')
          button.classList.add('font-semibold')
        } else {
          button.classList.remove('border-b-2')
          button.classList.remove('font-semibold')
        }
      }
    }

    return {
      init: function () {
        for (var i = 0; i < buttons.length; i++) {
          var button = buttons[i]
          var tabName = button.getAttribute('data-tab')
          button.addEventListener('click', onClick)
        }
      },
    }
  })

  faq_tab(document.querySelector('#faq-qa-fixed-content-section')).init()
})
